import React, {FC} from "react";
import {searchReportCashier} from "../../../serviceBroker/transationReportApiServiceBroker";
import {PageEnum, TransactionReportSearchParamsModel} from "../../../models";
import {ReportPage, ReportTransactionSearchPanel} from "../../../components";
import {getPageNameByPageId, getSystemLanguageId} from "../../../utils";

export const ReportCashier: FC = () => {
    const initialState: TransactionReportSearchParamsModel = {
        Lang: getSystemLanguageId(),
        lang: getSystemLanguageId(),
    };
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReportCashier}
            searchHeader={getPageNameByPageId(PageEnum.frmReportPosTransaction)}
            SearchPanel={ReportTransactionSearchPanel}
            formId={PageEnum.frmReportPosTransaction}
        />
    );
};
